<template>
  <div class="asset-indicators-wrapper">
    <PulseLoader
      v-if="loading"
      :loading="loading"
      color="#F5A623"
      size="1.5rem"
      style="margin:2rem auto;text-align:center"
    ></PulseLoader>

    <div v-if="!loading && !errorLoading" class="headline-carousel-wrapper">
      <carousel
        :navigationEnabled="true"
        :centerMode="false"
        :scrollPerPage="true"
        :paginationEnabled="false"
        :perPageCustom="[[0,2], [768, 5], [992, 7]]"
      >
        <slide class="asset-indicator-slide">
          <div class="slide-wrapper">
            <p class="indicator-title">Latest Trade</p>
            <p
              class="indicator-value"
            >{{(latestStockPrice.price == -1) ? "N/A" : latestStockPrice.price}} {{currency}}</p>
          </div>
        </slide>

        <slide class="asset-indicator-slide">
          <div class="slide-wrapper">
            <p class="indicator-title">Change Today</p>
            <p class="indicator-value" :style="priceChangeColor">{{priceChange}}</p>
          </div>
        </slide>

        <slide class="asset-indicator-slide">
          <div class="slide-wrapper">
            <p class="indicator-title">52 Week's Range</p>
            <p
              class="indicator-value"
            >{{financialSummary['week_52_range'].replace("undefined - undefined", "N/A - N/A")}}</p>
          </div>
        </slide>

        <slide class="asset-indicator-slide">
          <div class="slide-wrapper">
            <p class="indicator-title">Market Cap</p>
            <p class="indicator-value">{{financialSummary['market_cap']}}</p>
          </div>
        </slide>

        <slide class="asset-indicator-slide">
          <div class="slide-wrapper">
            <p class="indicator-title">P/E (TTM)</p>
            <p class="indicator-value">{{financialSummary['pe_ratio']}}</p>
          </div>
        </slide>

        <slide class="asset-indicator-slide">
          <div class="slide-wrapper">
            <p class="indicator-title">Divident Yield(%)</p>
            <p class="indicator-value">{{financialSummary['forward_dividend_yield']}}</p>
          </div>
        </slide>

        <slide class="asset-indicator-slide">
          <div class="slide-wrapper">
            <p class="indicator-title">
              Sentiment
              <span
                class="icon"
                data-toggle="sentiment-tooltip"
                data-placement="bottom"
                title="Sentiment score is calculated based on last 7 days of sentiments from +1 to -1."
                tabindex="0"
              >?</span>
            </p>
            <p class="indicator-value">{{financialSummary['sentiment']}}</p>
          </div>
        </slide>
      </carousel>
      <div class="carousel-footer">
        <p>As of {{latestStockPrice.minute}} {{latestStockPrice.timezone}} {{formatDate}}. Min 15 minute delay</p>
        <p>on the {{exchange}}</p>
      </div>
    </div>

    <div
      v-if="errorLoading"
      class="error-loading row"
    >Oops, Asset indicators will be back shortly. Please try again later...</div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { mapState } from "vuex";

export default {
  name: "AssetIndicators",

  components: {
    PulseLoader
  },

  computed: {
    ...mapState(["assetInfo"]),
    priceChange() {
      if (
        this.latestStockPrice.price == -1 ||
        this.lastCloseStockPrice.price == -1
      )
        return "N/A (N/A)";
      const change =
        this.latestStockPrice.price - this.lastCloseStockPrice.price;
      const percent = (change / this.lastCloseStockPrice.price) * 100;
      return `${change.toFixed(2)} (${percent.toFixed(2)}%)`;
    },
    formatDate() {
      if (this.latestStockPrice.date != "today")
        return (
          this.latestStockPrice.date.substr(0, 4) +
          "-" +
          this.latestStockPrice.date.substr(4, 2) +
          "-" +
          this.latestStockPrice.date.substr(6, 2)
        );
      else return "today";
    },
    priceChangeColor() {
      console.log(
        "[asset-indicators] this.latestStockPrice.price is: ",
        this.latestStockPrice.price
      );
      console.log(
        "[asset-indicators] this.lastCloseStockPrice.price is: ",
        this.lastCloseStockPrice.price
      );

      if (
        this.latestStockPrice.price == -1 ||
        this.lastCloseStockPrice.price == -1
      )
        return "color: black";
      else {
        const change =
          this.latestStockPrice.price - this.lastCloseStockPrice.price;
        return change < 0 ? "color: #c70400;" : "color: #0f9d58;";
      }
    }
  },

  data() {
    return {
      loading: true,
      errorLoading: false,

      currency: "USD",
      latestStockPrice: {
        date: "today",
        gmt_offset: 0,
        minute: "00:00:00",
        price: -1,
        ticker: "N/A",
        timezone: "EST",
        timezone_name: "America/New_York",
        volume: 0
      },
      lastCloseStockPrice: {
        date: "today",
        gmt_offset: 0,
        minute: "00:00:00",
        price: -1,
        ticker: "N/A",
        timezone: "EST",
        timezone_name: "America/New_York",
        volume: 0
      },
      financialSummary: {
        avg_volume: "N/A",
        beta: null,
        eps: "N/A",
        ex_dividend_date: "mm dd, yyyy",
        forward_dividend_yield: "N/A (N/A%)",
        market_cap: "N/A",
        open: "N/A",
        pe_ratio: "N/A",
        previous_close: -1,
        sentiment: 0,
        week_52_range: "N/A - N/A"
      },
      exchange: "N/A",
      timezone: "N/A"
    };
  },

  mounted() {
    this.getAssetIndicators();

    // subscribe to assetInfo value change
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setAssetInfo") {
        // console.log("mounted() asset info mutation...", this.assetInfo);
        this.clearIndicators();
        this.getAssetIndicators();
      }
    });
  },

  updated() {
    $('[data-toggle="sentiment-tooltip"]').tooltip();
  },

  methods: {
    getAssetIndicators() {
      this.loading = true;
      this.errorLoading = false;
      this.$store
        .dispatch("getAssetIndicatorData")
        .then(res => {
          res = res.data;
          console.log("getAssetIndicators() response is: ", res);

          if (res.hasOwnProperty("fs") && res["fs"])
            this.financialSummary = res["fs"];
          if (res.hasOwnProperty("lsp") && res["lsp"])
            this.latestStockPrice = res["lsp"];
          if (res.hasOwnProperty("lcsp") && res["lcsp"])
            this.lastCloseStockPrice = res["lcsp"];
          this.currency = res["c"];
          this.exchange = res["e"];
          this.timezone = res["t"];
          this.loading = false;
        })
        .catch(err => {
          console.log("getAssetIndicators() ERROR is: ", err);
          this.loading = false;
          this.errorLoading = true;
        });
    },

    clearIndicators() {
      this.currency = "USD";
      this.latestStockPrice = {
        date: "today",
        gmt_offset: 0,
        minute: "00:00:00",
        price: -1,
        ticker: "N/A",
        timezone: "EST",
        timezone_name: "America/New_York",
        volume: 0
      };
      this.lastCloseStockPrice = {
        date: "today",
        gmt_offset: 0,
        minute: "00:00:00",
        price: -1,
        ticker: "N/A",
        timezone: "EST",
        timezone_name: "America/New_York",
        volume: 0
      };
      this.financialSummary = {
        avg_volume: "N/A",
        beta: "N/A",
        eps: "N/A",
        ex_dividend_date: "mm dd, yyyy",
        forward_dividend_yield: "N/A (N/A%)",
        market_cap: "0",
        open: "N/A",
        pe_ratio: "N/A",
        previous_close: -1,
        sentiment: 0,
        week_52_range: "N/A - N/A"
      };
      this.exchange = "N/A";
      this.timezone = "N/A";
    }
  }
};
</script>

<style scoped>
.asset-indicators-wrapper {
  font-family: Raleway;
  padding: 0.5rem 1rem;
  margin: 0;
  border-bottom: 1px solid #d8d8d8;
}

.indicator-title {
  padding-top: 0.5rem;
  font-family: Raleway;
  font-size: 0.8rem;
  color: #4a4a4a;
}
.indicator-value {
  font-family: avenir;
  font-size: 1.2rem;
  color: #4a4a4a;
  padding-right: 0.5rem;
}

.icon {
  position: absolute;
  top: 0.1rem;
  font-size: 0.8rem;
  font-weight: bold;
  color: white;
  padding: 0 0.25rem;
  border-radius: 0.8rem;
  background: #d8d8d8;
  margin-left: 0.2rem;
  cursor: pointer;
}

.icon:focus {
  outline: none;
}

.carousel-footer {
  font-family: avenir;
  font-size: 0.7rem;
  color: #5a5c5c;
}

.error-loading {
  margin: 3rem;
  text-align: center;
}

/* Tooltip styling */
.tooltip-inner {
  font-size: 0.5rem;
}

@media (min-width: 768px) {
  .error-loading {
    margin: 3.5rem;
  }
}

@media (min-width: 992px) {
  .error-loading {
    margin: 4rem;
  }
}

@media (min-width: 1200px) {
  .slide-wrapper {
    min-width: 10rem;
  }
  .error-loading {
    margin: 5rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/insight-page-components/asset-indicators.vue